export default [
  {
    name: "Activity Tracker",
    path: '/activity-tracker',
    component: () => import('../components/activity_tracker/ActivityTracker.vue'),
    meta: {
      requiresAuth: true,
      hasAccess: ['admin'],
      layout: 'master'
    }
  }
]
